/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_02_LabelInputs */

const en_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & Governance`)
};

const de_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit & Governance`)
};

const fr_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const es_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const it_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const nl_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const pl_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const fi_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const da_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

const sv_landing_section_02_label = /** @type {(inputs: Landing_Section_02_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European infrastructure`)
};

/**
* | output |
* | --- |
* | "Security & Governance" |
*
* @param {Landing_Section_02_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_02_label = /** @type {((inputs?: Landing_Section_02_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_02_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_02_label(inputs)
	if (locale === "fr") return fr_landing_section_02_label(inputs)
	if (locale === "es") return es_landing_section_02_label(inputs)
	if (locale === "it") return it_landing_section_02_label(inputs)
	if (locale === "nl") return nl_landing_section_02_label(inputs)
	if (locale === "pl") return pl_landing_section_02_label(inputs)
	if (locale === "fi") return fi_landing_section_02_label(inputs)
	if (locale === "da") return da_landing_section_02_label(inputs)
	if (locale === "sv") return sv_landing_section_02_label(inputs)
	return en_landing_section_02_label(inputs)
});